import React from 'react';
import { motion } from 'framer-motion';
import './HeroSection.css';

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="hero-container">
        <motion.div
          className="hero-content"
          initial={{ opacity: 0, x: -100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          <h1 className="hero-title">Bulk Brilliance Unleashed</h1>
          <p className="hero-subtitle">
            VBC Services LTD: Your London-based cash & carry for unbeatable bulk deals, trader-first value, and nationwide reach.
          </p>
          <motion.a
            href="#shop"
            className="hero-cta"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
          >
            Stack Your Savings
          </motion.a>
        </motion.div>

        {/* <motion.div
          className="hero-visual"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, delay: 0.8 }}
        /> */}
      </div>

      <div className="hero-ticker">
        <span className="ticker-text">
          🔥 50% Off Bulk Snacks | Free Delivery on Orders Over £500 | New Trader Discounts Available Now 🔥
        </span>
      </div>
    </section>
  );
};

export default HeroSection;